import cardMixin from '../WSCD01-card-product-list/WSCD01-card-product/card-mixin.js';

export default {
	name: 'wspdt01-product-details',
	mixins: [
		cardMixin
	]
};



// WEBPACK FOOTER //
// ../source/modules/WSPDT01-product-details/WSPDT01-product-details.js